import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TooltipContent',
    props: {
        position: { default: 'bottom' },
        className: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const tooltipContent = tv({
            base: clsx('bg-gray-850 rounded-4 text-body-6 absolute z-(--zIndex-tooltip) w-max max-w-500 px-10 py-6 text-white', 'invisible group-hover:visible', 'after:content-[" "] after:absolute after:border-[6px] after:border-transparent'),
            variants: {
                position: {
                    top: clsx('bottom-(--tooltip-position) left-1/2 translate-x-[-50%]', 'after:border-t-gray-850 after:-bottom-12 after:left-1/2 after:translate-x-[-50%]'),
                    bottom: clsx('top-(--tooltip-position) left-1/2 translate-x-[-50%]', 'after:border-b-gray-850 after:-top-12 after:left-1/2 after:translate-x-[-50%]'),
                    left: clsx('top-1/2 right-(--tooltip-position) -translate-y-1/2', 'after:border-l-gray-850 after:top-1/2 after:-right-12 after:-translate-y-1/2'),
                    right: clsx('top-1/2 left-(--tooltip-position) -translate-y-1/2', 'after:border-r-gray-850 after:top-1/2 after:-left-12 after:-translate-y-1/2'),
                },
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                "aria-hidden": true,
                class: _normalizeClass(_unref(tooltipContent)({
                    position: props.position,
                    class: props.className,
                })),
                role: "tooltip"
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
